import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAeroPhotoTourActionTypes {
  OpenModal = 'aeroPhotoTour/openModal',
  CloseModal = 'aeroPhotoTour/closeModal',
}

export type TOpenAeroPhotoModal = ITypedReduxAction<EAeroPhotoTourActionTypes.OpenModal, void>;
export type TCloseAeroPhotoModal = ITypedReduxAction<EAeroPhotoTourActionTypes.CloseModal, void>;

export const openAeroPhotoModal = actionGenerator<EAeroPhotoTourActionTypes.OpenModal>(
  EAeroPhotoTourActionTypes.OpenModal,
);
export const closeAeroPhotoModal = actionGenerator<EAeroPhotoTourActionTypes.CloseModal>(
  EAeroPhotoTourActionTypes.CloseModal,
);

export type TAeroPhotoTourActions = TOpenAeroPhotoModal | TCloseAeroPhotoModal;
